import React from 'react'
import ButtonUI from '../../../widgets/action/ButtonUI'
import IconUploadButtonUI from '../../../widgets/action/IconUploadButtonUI'

const BankStatementsCollectUI = ({context, errorList, bankStatements, onBSUploadClick,
    onProceedClick}) =>
  <div>
    <div className='g_m_top_100'><b>Bank Statement(s)</b></div>
    <p>You need to upload Bank Statement(s) for all your Company bank account(s) for the period April 2019 till November 2021.</p>

    {bankStatements}

    <IconUploadButtonUI icon='icon-upload' onClick={onBSUploadClick}
                        label='Upload'/>


    <ButtonUI
      label='Proceed'
      transparent={false}
      onClick={onProceedClick}
      type={"button"}
    />
  </div>

export default BankStatementsCollectUI
